import { Flex, Image, ListItem, UnorderedList } from "@chakra-ui/react";
import CustomHeading from "../../components/text/CustomHeading";
import CustomText from "../../components/text/CustomText";
import CustomButton from "../../components/buttons/CustomButton";
import Logo from "../../assets/images/white-logo.svg";
import WdsLogo from "../../assets/images/wds-logo.png";
import BgImg from "../../assets/images/auth-bg.svg";
import { useNavigate } from "react-router-dom";
function Home() {
  const navigate = useNavigate();

  return (
    <Flex
      minH="100vh"
      py="20px"
      px="150px"
      flexDir="column"
      gap="50px"
      backgroundImage={`url(${BgImg})`}
      backgroundSize="cover"
      backgroundPosition="top"
      backgroundRepeat="no-repeat"
    >
      <Flex align="center" justify="space-between">
        <Image src={Logo} alt="Logo" w="124px" h="54px" />
        <Image src={WdsLogo} alt="WDS Logo" w="124px" h="54px" />
      </Flex>
      <Flex align="center" gap="24px">
        <Flex
          flexDir="column"
          gap="40px"
          borderRadius="24px"
          border="1px solid"
          borderColor="yess.border"
          bg="yess.g1"
          p="56px 40px"
          maxW="480px"
          w="100%"
        >
          <Flex flexDir="column">
            <CustomHeading text="YESS Visitor Portal" />
            <CustomText
              text="
              Welcome to the YESS Visitor Portal."
              color="yess.neutral600"
            />
          </Flex>
          <Flex gap="22px" flexDir="column" w="100%">
            <CustomButton
              btnTitle="Register Here"
              bg="yess.secondary_gold"
              maxW="100%"
              onClick={() => {
                navigate("/auth/signup");
              }}
            />
            <CustomButton
              btnTitle="Already Registered? Login Here"
              maxW="100%"
              onClick={() => {
                navigate("/auth/login");
              }}
            />
          </Flex>
        </Flex>
        <Flex flexDir="column" gap="10px">
          <CustomText
            text="Visitor Registration"
            size="24px"
            weight="700"
            color="#fff"
          />
          <CustomText
            text="Register today and be a part of the World Defense Show 2025, which will be held from 4th - 8th February 2025. Your registration will be vetted by our team, once it is approved you will receive a Print at Home badge closer to the event. We anticipate high numbers of registrations and spaces may be limited so secure your place today."
            color="#fff"
          />
          <CustomText
            text="This process will take approximately 5 minutes to complete and you will require:"
            color="#fff"
          />
          <UnorderedList color="#fff">
            <ListItem>
              <CustomText text="A photo of yourself" color="#fff" />
            </ListItem>
            <ListItem>
              <CustomText text="Copy of your passport & or ID" color="#fff" />
            </ListItem>
            <ListItem>
              <CustomText text="Payment" color="#fff" />
            </ListItem>
          </UnorderedList>
          <CustomText
            text="If you have been invited by an exhibitor, please have your promo code ready to complete the payment."
            color="#fff"
          />
          <CustomText
            text="Email communications will be sent to you about the event which are important to your visit so please ensure you look out for them and follow us on social media."
            color="#fff"
          />
          <CustomText
            text="IMPORTANT NOTE: International visitors may require a visa to enter the Kingdom of Saudi Arabia. Additional information on how to apply for your visa will be provided within the registration approval email."
            color="#fff"
          />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default Home;
